// extracted by mini-css-extract-plugin
export var container = "Special-module--container--3ZFU-";
export var container1 = "Special-module--container1--YpRYl";
export var container2 = "Special-module--container2--VLimM";
export var containerNarrow = "Special-module--container-narrow--diA07";
export var containerWide = "Special-module--container-wide--DUTkl";
export var fontDisplay = "Special-module--font-display--pM8Wc";
export var fontSansSerif = "Special-module--font-sans-serif--XJCzz";
export var hover = "Special-module--hover--mdeTi";
export var linkUl = "Special-module--link-ul--fzr69";
export var lock = "Special-module--lock--J-zYt";
export var mainInner = "Special-module--main-inner--k3WKU";
export var modal = "Special-module--modal--lgg-O";
export var modal__container = "Special-module--modal__container--9-KZ5";
export var modal__description = "Special-module--modal__description--VxAj0";
export var modal__embed = "Special-module--modal__embed--AfmQ-";
export var modal__title = "Special-module--modal__title---CSvK";
export var onlyForMedium = "Special-module--only-for-medium--QSKTV";
export var onlyForSmall = "Special-module--only-for-small--SQhq9";
export var overlay = "Special-module--overlay--+tufl";
export var pageTitleWrapper = "Special-module--page-title-wrapper--r+4Ph";
export var root = "Special-module--root--hEy0y";
export var spFull = "Special-module--sp-full--PviKI";
export var special__item = "Special-module--special__item--vcwTO";
export var special__item__casestudy__left = "Special-module--special__item__casestudy__left--JakQx";
export var special__item__casestudy__right = "Special-module--special__item__casestudy__right--rQmth";
export var textCenter = "Special-module--text-center--BqxGZ";
export var textLeft = "Special-module--text-left--j99Td";
export var textRight = "Special-module--text-right--i5zU6";